import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../css/latestnewsblog.css';
import ChatbotAi from "../components/ChatbotAi";
import { Helmet } from "react-helmet-async";

const Blog = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_URL = process.env.REACT_APP_Dashboard_API_URL;

  useEffect(() => {
    fetchBlogs();
  }, []);

 const fetchBlogs = async () => {
    try {
        setLoading(true);
        const response = await axios.get(`${API_URL}Blogs`);
        const blogs = response.data.map(blog => {
            const titleSlug = blog.subheading
                ? blog.subheading
                    .toLowerCase()
                    .trim()
                    .replace(/[^\w\s-]/g, '')
                    .replace(/[\s_-]+/g, '-')
                    .replace(/^-+|-+$/g, '')
                : `blog-${blog.id}`;

            return {
                transformed: {
                    id: blog.id,
                   image: blog.imagePath
    ? `${process.env.REACT_APP_Dashboard_API_URL.split('/api')[0]}/${blog.imagePath}`
    : 'https://placehold.co/350x200?text=No+Image',

                    title: blog.subheading,
                    author: blog.author || "Policy Samjho Team",
                    date: blog.publishDate
                        ? new Date(blog.publishDate).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                        })
                        : "-",
                    slug: titleSlug,
                },
                original: blog,
            };
        });

        setBlogPosts(blogs);
    } catch (error) {
        console.error("Error fetching blogs:", error.response?.data || error.message);
    }
    finally {
        setLoading(false);
    }
};


  return (
    <div className="newsblog-container-main" id="latestnewsblog">
      <Helmet>
        <title>Insurance Blogs & Expert Advice | PolicySamjho</title>
        <meta
          name="description"
          content="Read expert-written insurance blogs from PolicySamjho. Understand insurance policies, avoid mistakes, and get clear guidance on health, life, motor, and more."
        />
        <meta 
          name="keywords" 
          content="insurance guidance, policy consultation, insurance expert advice, insurance policy review, insurance advice India, understand insurance policy" 
        />
        <link rel="canonical" href="https://policysamjho.com/blogs/" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Blog",
            "name": "Policy Samjho Insurance Blog",
            "url": "https://policysamjho.com/blogs/",
            "description": "Expert insurance blogs offering clear guidance, policy explanations, and advice for Indian users.",
            "publisher": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com/",
              "logo": {
                "@type": "ImageObject",
                "url": "https://policysamjho.com/policySamjhoFaviconLogo.png"
              }
            }
          })}
        </script>
      </Helmet>

      <p className="newsblog-container-recent-feed">
        &gt;&gt;&gt; RECENT NEWS FEED &lt;&lt;&lt;
      </p>

      <h2 className="newsblog-container-heading">
        Latest insurance news & articles from our blog
      </h2>

      <div className="newsblog-container-cards-wrapper">
        {loading ? (
    <div style={{ width: '100%', textAlign: 'center', padding: '40px', fontSize: '18px', color: '#666' }}>
      Loading blogs...
    </div>
  ) : blogPosts.length > 0 ? (
    blogPosts.map(({ transformed, original }) => (
            <Link 
              key={transformed.id} 
              to={`/blogs/${transformed.slug}`} 
              state={{ post: original }}
              className="newsblog-container-card"
            >
              <div className="newsblog-container-card-image-wrapper">
                <span className="newsblog-container-policy-tag">POLICY SAMJHO</span>
                <img
                  src={transformed.image}
                  alt={transformed.title}
                  className="newsblog-container-card-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://placehold.co/350x200?text=Image+Error';
                  }}
                />
              </div>

              <div className="newsblog-container-card-content">
                <h3 className="newsblog-container-card-title">
                  {transformed.title}
                </h3>

                <div className="newsblog-container-card-meta">
                  <div className="newsblog-container-author-icon">
                    <img
                      src={`${process.env.PUBLIC_URL}/policySamjhoFaviconLogo.png`}
                      alt="Author Icon"
                      style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                    />
                  </div>
                  <div className="newsblog-container-author-info">
                    <span className="newsblog-container-author-name">
                      By {transformed.author} 
                    </span>
                    <span className="newsblog-container-post-date">
                      {transformed.date}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))
        ) : (
          <p className="text-center text-gray-500 w-full">No blogs found.</p>
        )}
      </div>
      <ChatbotAi />
    </div>
  );
};

export default Blog;